"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montegrosso-d-asti": {
    "4d6081d6": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "basolo": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90697366": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "gallareto": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13a62808": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "messadio": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c2e3cd29": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c06ba7fb": [{
      "hkey": "5c29cc7c",
      "slug": "santo-stefano-canetto",
      "name": "Santo Stefano-Canetto",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "5c29cc7c",
      "slug": "santo-stefano-canetto",
      "name": "Santo Stefano-Canetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1fae6c94": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "valenzano": [{
      "hkey": "8a0fb526",
      "slug": "montegrosso-d-asti",
      "name": "Montegrosso d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;